import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';

@Component({
  selector: 'app-ba-list-period-setup-list',
  templateUrl: './../../../templates/forms/modals/ba-list-period-setup.component.html',
})
export class BaListPeriodSetupComponent implements OnInit {
  @Input()
  ACC_NO: any;
  
  @Input()
  modalShow: boolean = true;

  @Input()
  extValueThird;

  @Input()
  extValueFourth;
  
  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj:any;

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "BaListPeriodSetupGrid"

  baList:any[] = [];
  searchFields:any[] = ['BA_NAME'];
  public searchString;
  constructor(private dataService: CommonService,
    public langService: LangService,
    public gridService:GridService) { 
      this.colObj = [
        { headerName: langService.langData.baNameCap, field: 'BA_NAME', sortable: true, resizable: true, hide: false },
        { headerName: langService.langData.baNo, field: 'BA_NO', sortable: true, resizable: true, hide: false },
      ];
    }

  ngOnInit() {  
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId); 
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    if(this.extValueFourth) {
      this.dataService.getBusinessAreas(this.extValueFourth, this.ACC_NO )
      .subscribe(arg => {this.baList = arg.body});
    }
    else if(this.extValueThird) {
      this.dataService.getBusinessAreas(this.extValueThird)
      .subscribe(arg => {this.baList = arg.body});
    }else {
    this.dataService.getChartBalist( this.ACC_NO )
    .subscribe(arg => {this.baList = arg.body});
  }
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next();
  }

} 